import {
  defineProductDimensions,
  nomenclatureVersionDimension,
  rcdaPricingVersionDimension,
  rcdaSelectedDimension,
} from '@orus.eu/dimensions'

import { rcdaQuoteDimension } from './rcda-quote-dimension.ts'

export * from './rcda-activity-vocabulary.ts'
export * from './rcda-complementary-documents-dimension.ts'
export * from './rcda-dimensions.ts'
export * from './rcda-subscription-ui.ts'
export * from './rcda-ui-elements.ts'
export * from './subscription-detailed-sheet-dimension.ts'

export const rcdaDimensionsModule = defineProductDimensions({
  product: 'rcda',
  family: null,
  selectionDimension: rcdaSelectedDimension,
  legacyVersionDimension: nomenclatureVersionDimension, // name 'nomenclatureVersion' — permanent override (D6), never renamed
  pricingVersionDimension: rcdaPricingVersionDimension,
  quoteV2Dimension: rcdaQuoteDimension,
})
